import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { authToken } from "./Authentication";
import { Grid, IconButton, TextField } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";

export default function LogsView({ url }: { url: string }) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  const [logText, setLogText] = useState("");
  const textFieldRoot = useRef(null);
  let [nextToken, setNextToken] = useState(null);
  //TODO refactor - move away from setLogText and checking for last chunk

  async function fetchMoreLogs() {
    if (url === "") return;
    const response = await axios.get(url, {
      params: { nextToken, limit: 100 },
    });
    const chunk = response.data.events
      .map((event: { message: string; timestamp: number }) => {
        const timestamp = new Date(event.timestamp).toUTCString();
        const info = event.message.replaceAll(/\[\d+?m/g, "");
        return `[${timestamp}] ${info}`;
      })
      .join("\n");

    setLogText(logText + "\n" + chunk);

    if (textFieldRoot.current) {
      const textarea = (textFieldRoot.current as any).querySelector(
        "textarea"
      ) as HTMLElement;
      textarea.scrollTop = textarea.scrollHeight;
    }

    if (response.data.nextToken) {
      setNextToken(response.data.nextToken);
    }
  }

  useEffect(() => {
    fetchMoreLogs();
    // eslint-disable-next-line
  }, [nextToken]);

  useEffect(() => {
    console.log(url);
    setLogText("");
    fetchMoreLogs();
    // eslint-disable-next-line
  }, [url]);

  return (
    <>
      <Grid container justify="center">
        <TextField
          ref={textFieldRoot}
          multiline
          fullWidth
          variant="filled"
          value={logText.trim() || "No logs to show"}
          inputProps={{
            readOnly: "readonly",
            rows: 20,
            rowsMax: 20,
            style: { fontFamily: "monospace", color: "#212121" },
          }}
        />
      </Grid>
      <IconButton onClick={() => fetchMoreLogs()}>
        <RefreshIcon />
      </IconButton>
    </>
  );
}
